function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { useMemo } from "react";
import { getRates, getUserCurrencyCode } from "../api/fx";

var FX = /*#__PURE__*/function () {
  function FX() {
    _classCallCheck(this, FX);

    this.code = undefined;
    this.rates = {};
    this.ready = false;
    this.init();
  }

  _createClass(FX, [{
    key: "init",
    value: function init() {
      var _this = this;

      getRates().then(function (rates) {
        if (rates) {
          _this.rates = rates;
        }
      }).then(function () {
        return getUserCurrencyCode();
      }).then(function (res) {
        if (res) {
          _this.code = res.code;
          _this.ready = true;
        }
      });
    }
  }, {
    key: "getUserCurrencyCode",
    value: function getUserCurrencyCode() {
      return this.code;
    }
  }, {
    key: "buy",
    value: function buy(amount, from, to) {
      return amount / this.rates[from][to];
    }
  }, {
    key: "renderPrice",
    value: function renderPrice(price, currencyCode) {
      var round = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      /*
        converts the price from the currencyCode to the user currency,
        rounds it and formats it using toLocaleString then removes the
        decimal places that toLocaleString puts in.
        */
      if (!this.ready) return "";
      var renderedPrice = Math.round(this.buy(price, this.code, currencyCode)).toLocaleString("en", {
        currency: this.code,
        style: "currency",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      });

      if (round) {
        return renderedPrice.slice(0, -3);
      }

      return renderedPrice;
    }
  }]);

  return FX;
}();

var useFx = function useFx() {
  var renderPrice = useMemo(function () {
    var fx = new FX();
    return fx.renderPrice.bind(fx);
  }, []);
  return renderPrice;
};

export default useFx;